/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { EventArgs, markType } from "igniteui-react-core";
/**
 * @hidden
 */
var GridSelectedItemsChangedEventArgs = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(GridSelectedItemsChangedEventArgs, _super);
    function GridSelectedItemsChangedEventArgs() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._currentItems = null;
        _this._addedItems = null;
        _this._removedItems = null;
        return _this;
    }
    Object.defineProperty(GridSelectedItemsChangedEventArgs.prototype, "currentItems", {
        get: function () {
            return this._currentItems;
        },
        set: function (a) {
            this._currentItems = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridSelectedItemsChangedEventArgs.prototype, "addedItems", {
        get: function () {
            return this._addedItems;
        },
        set: function (a) {
            this._addedItems = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(GridSelectedItemsChangedEventArgs.prototype, "removedItems", {
        get: function () {
            return this._removedItems;
        },
        set: function (a) {
            this._removedItems = a;
        },
        enumerable: true,
        configurable: true
    });
    GridSelectedItemsChangedEventArgs.$t = markType(GridSelectedItemsChangedEventArgs, 'GridSelectedItemsChangedEventArgs', EventArgs.$);
    return GridSelectedItemsChangedEventArgs;
}(EventArgs));
export { GridSelectedItemsChangedEventArgs };
//# sourceMappingURL=GridSelectedItemsChangedEventArgs.js.map
